// #region Dependencias
import { useState } from 'react'
import { IconPicker as IconPickerSelector, IconPickerItem } from 'react-fa-icon-picker'
import { colors } from 'components/Library/theme'
// #endregion

/**
 * Componente que renderiza un icono con la posibilidad de mostrar
 * un selector en modo edición.
 * @class
 * {@see https://www.npmjs.com/package/react-fa-icon-picker react-fa-icon-picker}
 *
 * @param {object} props - Propiedades del componente.
 * @param {boolean} props.modoEdicion - Valor que indica si el componente se encuentra en modo edición.
 * @param {Function} props.handleInputChange - Callback para manejar el cambio de valor del icono seleccionado.
 * @param {string} props.name - Nombre del input donde se guarda el valor del icono seleccionado.
 * @param {string} props.value - Valor del icono seleccionado.
 * @param {number} props.size - Tamaño del icono en píxeles.
 * @param {string} props.color - Color del icono.
 */
const IconPicker = ({
  modoEdicion = false,
  handleInputChange,
  name,
  value,
  size,
  color,
  ...props
}) => {
  const [hover, setHover] = useState()

  /**
   * Función para manejar el cambio del ícono seleccionado en el formulario.
   * @param {string} icono - Ícono seleccionado.
   */
  const handleIconChange = (icono) => {
    handleInputChange({
      target: {
        name,
        value: icono
      }
    })
  }

  return (
    <span onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      {!modoEdicion && <IconPickerItem icon={value} color={color} size={size} {...props} />}
      {modoEdicion && (
        <IconPickerSelector
          value={value}
          onChange={handleIconChange}
          buttonIconStyles={{
            color,
            display: 'flex',
            fontSize: size,
            padding: 0
          }}
          buttonStyles={{
            border: 0,
            boxShadow: hover ? `0px 0px 0px 2px ${colors.secondary}` : '',
            padding: 0,
            marginBottom: '.25rem'
          }}
          {...props}
        />
      )}
    </span>
  )
}

export default IconPicker
